// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__mV6ou","dragIcon":"SortableItem_dragIcon__2jkbA","disabled":"SortableItem_disabled__2LLjA"};